import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import { bindActionCreators } from 'redux';

import { connect, Provider } from 'react-redux';

// Import the Flexbox Patterns examples' styles.
import 'flexbox-patterns/dist/styles.css';

import {
  store,
  goToRoute,
  setMinimizedView,
  closeSideBar,
  openSideBar,
} from './application';

import { AppChrome } from './ui/views';

// Import our own styles.
import './index.scss';

// Add favicon files to the webpack bundle.
import './assets/images/favicons/android-chrome-144x144.png';
import './assets/images/favicons/android-chrome-192x192.png';
import './assets/images/favicons/android-chrome-36x36.png';
import './assets/images/favicons/android-chrome-48x48.png';
import './assets/images/favicons/android-chrome-72x72.png';
import './assets/images/favicons/android-chrome-96x96.png';
import './assets/images/favicons/apple-touch-icon-114x114.png';
import './assets/images/favicons/apple-touch-icon-120x120.png';
import './assets/images/favicons/apple-touch-icon-144x144.png';
import './assets/images/favicons/apple-touch-icon-152x152.png';
import './assets/images/favicons/apple-touch-icon-180x180.png';
import './assets/images/favicons/apple-touch-icon-57x57.png';
import './assets/images/favicons/apple-touch-icon-60x60.png';
import './assets/images/favicons/apple-touch-icon-72x72.png';
import './assets/images/favicons/apple-touch-icon-76x76.png';
import './assets/images/favicons/apple-touch-icon-precomposed.png';
import './assets/images/favicons/apple-touch-icon.png';
import './assets/images/favicons/browserconfig.xml';
import './assets/images/favicons/favicon-16x16.png';
import './assets/images/favicons/favicon-194x194.png';
import './assets/images/favicons/favicon-32x32.png';
import './assets/images/favicons/favicon-96x96.png';
import './assets/images/favicons/favicon.ico';
import './assets/images/favicons/manifest.json';
import './assets/images/favicons/mstile-144x144.png';
import './assets/images/favicons/mstile-150x150.png';
import './assets/images/favicons/mstile-310x150.png';
import './assets/images/favicons/mstile-310x310.png';
import './assets/images/favicons/mstile-70x70.png';
import './assets/images/favicons/safari-pinned-tab.svg';

// Track Google analytics.
ReactGA.initialize('G-QHP2TJYE6F');

function mapStateToProps(state) {
  return {
    isMinimizedView: state.view.isMinimized,
    isSideBarOpen: state.view.isSideBarOpen,
    pages: state.pages,
    router: state.router,
    page: state.page.page,
  };
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setMinimizedView,
    closeSideBar,
    openSideBar,
    goToRoute,
  };
  return bindActionCreators(actions, dispatch);
}

const App = connect(mapStateToProps, mapDispatchToProps)(AppChrome);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./index.js